const STATES = {
  NEW: 'NEW',
  CSR_LOADED: 'CSR_LOADED',
  CERT_SIGNED: 'CERT_SIGNED',
  VALID: 'VALID',
  INVALID: 'INVALID',
};

export { STATES };
